import * as React from "react";
import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import TSlideDrawer from "../../../common/TSlideDrawer";

import * as gbu from "../../../GB/GBUtil";

import * as pias from "../../NonComponents/PIAppState";
import * as pip from "../../NonComponents/PIProps";
import * as php from "../../NonComponents/PIHelp";
import PIHIVIncidByAgeSexRefForm from "../../Forms/Reference/PIHIVIncidByAgeSexRefForm";
//import THelpButton from "../../../common/THelpButton";

class PIHIVIncidByAgeSexRefSlideDrawer extends React.Component {
  static propTypes = {
    [pias.helpAreaStr]: PropTypes.string,
    [pias.onHelp]: PropTypes.func,

    [pias.modVarObjList]: PropTypes.arrayOf(PropTypes.object),

    [pip.onToggleRefSlideDrawer]: PropTypes.func,
  };

  static defaultProps = {
    [pias.helpAreaStr]: php.disagTarg_HIV_AgeSexRD_HP,
    [pias.onHelp]: () => console.log(pias.onHelp),

    [pias.modVarObjList]: [],

    [pip.onToggleRefSlideDrawer]: () => console.log(pip.onToggleRefSlideDrawer),
  };

  //==================================================================================================================
  //
  //                                        Life Cycle Events
  //
  //==================================================================================================================

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return gbu.shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
  }

  //==================================================================================================================
  //
  //                                              Event Handlers
  //
  //==================================================================================================================

  onHelpBtnClick = () => {
    this.props.onHelp();
  };

  //==================================================================================================================
  //
  //                                              Render
  //
  //==================================================================================================================

  render() {
    /* props */

    const props = this.props;
    const modVarObjList = props[pias.modVarObjList];
    const onToggleRefSlideDrawer = props[pip.onToggleRefSlideDrawer];

    /* state */

    //const state = this.state;

    const formComp = (
      <PIHIVIncidByAgeSexRefForm
        {...{
          [pias.modVarObjList]: modVarObjList,
        }}
      />
    );

    const slideDrawer = (
      <TSlideDrawer
        anchor={"right"}
        onClose={onToggleRefSlideDrawer}
        content={formComp}
        headerTitleStyle={{
          color: Theme.PI_PrimaryColor,
        }}
        saveButton={false}
        title={RS(SC.GB_stHIVIncidByAgeSex)} //RS(SC.GB_stReference)}
        width={Theme.slideDrawerLv2Width}
        //helpBtn={<THelpButton Theme={Theme} onClick={this.onHelpBtnClick} />}
      />
    );

    return slideDrawer;
  }
}

export default PIHIVIncidByAgeSexRefSlideDrawer;
